import { fill } from "lodash";
import React from "react";

const ViewIcon = ({ width = "20px", height = "20px", fill = "#428DFE" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7.5V5.5C3 4.96957 3.21071 4.46086 3.58579 4.08579C3.96086 3.71071 4.46957 3.5 5 3.5H7"
        stroke={fill}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 3.5H19C19.5304 3.5 20.0391 3.71071 20.4142 4.08579C20.7893 4.46086 21 4.96957 21 5.5V7.5"
        stroke={fill}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 17.5V19.5C21 20.0304 20.7893 20.5391 20.4142 20.9142C20.0391 21.2893 19.5304 21.5 19 21.5H17"
        stroke={fill}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 21.5H5C4.46957 21.5 3.96086 21.2893 3.58579 20.9142C3.21071 20.5391 3 20.0304 3 19.5V17.5"
        stroke={fill}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 13.5C12.5523 13.5 13 13.0523 13 12.5C13 11.9477 12.5523 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5C11 13.0523 11.4477 13.5 12 13.5Z"
        stroke={fill}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.944 12.83C19.0187 12.6164 19.0187 12.3837 18.944 12.17C18.381 10.7905 17.4198 9.60985 16.1831 8.77879C14.9463 7.94774 13.4901 7.50391 12 7.50391C10.51 7.50391 9.05372 7.94774 7.81696 8.77879C6.58021 9.60985 5.61903 10.7905 5.05602 12.17C4.98133 12.3837 4.98133 12.6164 5.05602 12.83C5.61903 14.2096 6.58021 15.3902 7.81696 16.2213C9.05372 17.0523 10.51 17.4962 12 17.4962C13.4901 17.4962 14.9463 17.0523 16.1831 16.2213C17.4198 15.3902 18.381 14.2096 18.944 12.83Z"
        stroke={fill}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ViewIcon;
